export default __webpack_public_path__ + "static/media/ML Icon.2b4c8260.png";